import { render, staticRenderFns } from "./AdminNewUserButton.vue?vue&type=template&id=466bf173"
import script from "./AdminNewUserButton.vue?vue&type=script&lang=js"
export * from "./AdminNewUserButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports